import { Outlet } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { ToastProvider } from '@xcentral/ui';
import { getMsalInstance } from '../auth/msalInstance';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { ScrollToTop } from '../components/ScrollToTop';

export function RootLayout() {
  const instance = getMsalInstance();

  const content = (
    <>
      <ScrollToTop />
      <Outlet />
    </>
  );

  if (!instance) {
    // SSG render (Node) or pre-init: no MSAL/Toast context.
    // Auth-aware UI inside descendants must guard with <ClientOnly>.
    return <ErrorBoundary>{content}</ErrorBoundary>;
  }

  return (
    <ErrorBoundary>
      <MsalProvider instance={instance}>
        <ToastProvider>{content}</ToastProvider>
      </MsalProvider>
    </ErrorBoundary>
  );
}
